/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { ProfileImage, Text } from "UpduoLibrary";
import { upduoLightGray } from "config/UpduoColors";
import ManagerDashboardWidget from "./ManagerDashboardWidget";
import { LeaderType } from "./types";

export default function ManagerInfoWidget({
  manager,
}: {
  manager: LeaderType | undefined;
}) {
  const hireDate = (manager?.hireDate && new Date(manager.hireDate)) || null;
  const hireDateStr = hireDate?.toLocaleDateString();
  const now = new Date();
  const tenureTimeYears =
    hireDate && now.getFullYear() - hireDate.getFullYear();

  const body = manager ? (
    <>
      <ProfileImage
        userObject={manager}
        size={75}
        style={{ marginBottom: 16, marginHorizontal: 16 }}
      />
      <Text>{`${manager.firstName} ${manager.lastName}`}</Text>
      {hireDateStr && <Text>{`Hire Date: ${hireDateStr}`}</Text>}
      {tenureTimeYears && <Text>{`Tenure: ${tenureTimeYears}`}</Text>}
    </>
  ) : (
    <Text style={{ color: upduoLightGray }}>
      {"No manager set for this location"}
    </Text>
  );
  return (
    <ManagerDashboardWidget style={{ minHeight: 180 }} title={"Manager Info"}>
      <View
        style={{
          width: 220,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {body}
      </View>
    </ManagerDashboardWidget>
  );
}
